export default __webpack_public_path__ + "static/media/bg-result-waiting.e99535b8.svg";